import { gql } from "@apollo/client";

const GET_INVOICE_LATEST_VALIDATION_RESULT = gql`
  query getInvoiceLatestValidationResult(
    $clientIdentifier: String!
    $invoiceId: String!
  ) {
    invoice(clientIdentifier: $clientIdentifier, invoiceId: $invoiceId) {
      id
      invoiceFileId
      invoiceNumber
      state {
        assessmentStatus
        processStatus
        registrationStatus
        validationStatus
      }
      createdAt
      dueDate
      invoiceDate
      invoiceFee
      invoiceNumber
      totalVatAmount
      currencyCode
      shippingCost
      shippingFeeVatPercentage
      rounding
      invoiceIssuer {
        issuerReference
        client {
          id
        }
      }
      invoiceRecipient {
        name
        recipientEmail
        address1
        address2
        city
        countryCode
        customerCode
        zipCode
        client {
          id
        }
        isForeignIdentifier
        clientIdentifier
        distributionType
      }
      modifiedAt
      totalAmountWithVat
      tags {
        tag
      }
      rows {
        articleNumber
        description
        quantity
        unitPrice
        unitType
        discountPercentage
        discountAmount
        vatPercentage
        totalVatAmount
        invoiceRowId
        totalWithoutVAT
      }
      latestValidation {
        isValid
        invoiceId
        invoiceDataValidationId
        createdAt
        fieldValidations {
          createdAt
          fieldType
          invoiceFieldDataValidationId
          isValid
          value
        }
        rowValidations {
          createdAt
          invoiceRowDataValidationId
          invoiceRowId
          isValid
          rowFieldValidations {
            createdAt
            fieldType
            invoiceFieldDataValidationId
            isValid
            value
          }
        }
        ruleValidations {
          invoiceValidationDeterminationId
          message
          result
          rules {
            invoiceValidationDeterminationRuleId
            message
            passed
            ruleName
            ruleType
            score
            warning
          }
        }
      }
      uploadDocument {
        id
        comments(skip: 0, take: 5) {
          totalCount
          items {
            content
            createdAt
            createdByUser {
              id
              firstName
              lastName
            }
            id
          }
        }
        invoiceRecipientEmails
        invoiceRecipientGln
        userMessage
        serviceType
        invoiceUploadUnit {
          id
          emailDetails {
            isHtml
            messageId
            previewBody
            rawBody
            receivedDate
            recipients
            sentFromEmail
            subject
          }
          isBlacklisted
        }
      }
      serviceType
      template {
        id
        name
      }
      hasDuplicateInvoices
      isCreditInvoice
      vatReverseCharge
      externalErrorMessage
    }
  }
`;

export default GET_INVOICE_LATEST_VALIDATION_RESULT;
